import React from 'react';
import { Stack } from '@chakra-ui/react';

export const pageContentGap = "1em";

const PageContent = ({ gap=pageContentGap, children }) => {
  return (
    <Stack gap={gap}>
      {children}
    </Stack>
  );
};

export default PageContent;